import { useState } from 'react';
import classNames from 'classnames';
import { ExpandButton } from '@medifind/shared-basic-components';
import { isPrerender } from '@medifind/utils';
import ClinicalTrialRequest from './ClinicalTrialRequest/ClinicalTrialRequest';
import styles from './ClinicalTrialShared.module.scss';

const ClinicalTrialLocation = ({ location, contacts, trialName }) => {
  const size = location.locations.length;
  const showExpander = size > 5;
  const [isExpanded, setIsExpanded] = useState(!showExpander || isPrerender);
  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div
        className={classNames(styles['location-heading-container'], { [styles['clickable']]: showExpander })}
        onClick={() => showExpander && setIsExpanded(!isExpanded)}
        tabIndex={-1}
      >
        <div>{location.displayName}</div>
        {showExpander && <ExpandButton isExpanded={isExpanded} size="medium" title={location.displayName} />}
      </div>

      {isExpanded &&
        location.locations.map((location, i) => {
          return (
            <div key={`${location.postalCode}-${i}`} className={styles['location-container']}>
              <div className={styles['location-container__name']}>{location.orgName}</div>
              <div className={styles['location-container__status']}>{location.status}</div>
              <div className={styles['location-container__city']}>{location.city}</div>
              <div className={styles['location-container__contact-button']}>
                {location.status === 'Recruiting' && <ClinicalTrialRequest trialName={trialName} location={location} contacts={contacts} />}
              </div>
            </div>
          );
        })}
    </>
  );
};

export { ClinicalTrialLocation as default, ClinicalTrialLocation };
